module.exports = __webpack_public_path__ + "img/LOGO_NEU_ADMINPANEL.svg";